/** Rounds a number to two decimal places using decimal string formatting. */
export function roundToTwoDecimals(value: number | string): number {
  if (typeof value === 'string') {
    return parseFloat(Number(value).toFixed(2));
  } else {
    return parseFloat(value.toFixed(2));
  }
}
